import React from "react";
import { Section, FadeUp, SectionHeading } from "./primitives";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { faqs } from "@/data/content";

export const Faq = () => (
  <Section className="bg-white">
    <div className="max-w-[720px] mx-auto">
      <FadeUp className="text-center">
        <SectionHeading>Frequently Asked Questions</SectionHeading>
      </FadeUp>
      <FadeUp delay={0.05}>
        <Accordion type="single" collapsible className="mt-10 w-full">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} data-testid={`faq-item-${i}`} className="border-b border-zinc-200">
              <AccordionTrigger className="text-left text-lg font-bold text-zinc-900 hover:no-underline py-5">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-base md:text-lg text-zinc-600 leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </FadeUp>
    </div>
  </Section>
);
